import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import axios from "axios"; // backend will be commented
// import { API } from '../API';
import SchoolSidebar from "./SchoolSidebar";
import swal from "sweetalert";
// Mock Dropdown Data
const genders = ["Boy", "Girl"];

export default function SchoolUniformForm() {
  const [form, setForm] = useState({
    enrollment: "",
    group: "",
    gender: "",
    grade: "",
    name: "",
    student: "",
    products: [],
    schoolId: localStorage.getItem("schoolID"),
  });

  const [products, setProducts] = useState([]);
  const [mode, setMode] = useState("");
  const [enrollmentNumbers, setEnrollmentNumbers] = useState([]);
  const [studentNames, setStudentNames] = useState([]);
  const [grades, setGrades] = useState([]);
  const [gorb, setGorB] = useState([]);
  const [data, setData] = useState([]);
  const [gOrbData, setGorbData] = useState([]);
  const [size_guide, setSizeGuide] = useState([]);
  const [sockGuides, setSockGuides] = useState([]);
  const [trackGuide, setTrackGuide] = useState([]);
  const [height, setHeight] = useState(null);

  useEffect(() => {
    const fetchSchool = async () => {
      try {
        const schoolId = localStorage.getItem("schoolID");
        const resp = await axios.get(
          `/api/schooluniform/get-students-by-school/${schoolId}`
        );
        const students = resp.data.data;
        const gOrb = resp.data.gOrb;

        // Extract dropdown values
        const enrollmentList = students.map((s) => s.enrollment_number);
        const studentNameList = students.map((s) => s.name);

        // Extract grade dropdown (store only grade._id)
        const gradeList = students.map((s) => ({
          id: s.grade?._id,
          name: s.grade?.name,
        }));

        const gOrbList = Array.from(
          new Map(
            gOrb.map((s) => [s._id, { id: s._id, name: s.name }])
          ).values()
        );

        // Optional: remove duplicates
        const uniqueGrades = Array.from(
          new Map(gradeList.map((g) => [g.id, g])).values()
        );

        // Update states
        setEnrollmentNumbers(enrollmentList);
        setStudentNames(studentNameList);
        setGrades(uniqueGrades);
        setGorB(gOrbList);
        setMode(resp.data.option);
        setData(students);
        setGorbData(gOrb);
        setGorB(gOrb);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSchool();
  }, []);

  useEffect(() => {
    const fetchTrackGuides = async () => {
      try {
        const res = await axios.get(`/api/track-guides`);
        console.log("the res is ", res.data);
        setTrackGuide(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchTrackGuides();
  }, []);

  useEffect(() => {
    if (!form.grade || !grades.length) return;

    const schoolId = localStorage.getItem("schoolID");

    const fetchSockGuides = async () => {
      try {
        const res = await axios.get(`/api/socks-guide/school/${schoolId}`);

        const mappingData = res.data?.[0]?.mappingData || [];

        const selectedGrade = grades.find((g) => g.id === form.grade);
        if (!selectedGrade) return;

        const gradeMapping = mappingData.find(
          (item) =>
            item.grade?.trim().toLowerCase() ===
            selectedGrade.name?.trim().toLowerCase()
        );

        setSockGuides(gradeMapping || {});
      } catch (err) {
        console.error(err);
      }
    };

    fetchSockGuides();
  }, [form.grade, grades]);

  useEffect(() => {
    if (!form.gender || !form.grade || !form.student) return;

    // Auto-fill enrollment
    const matchedStudent = data.find(
      (s) =>
        s.name === form.student &&
        s.gender === form.gender.toLowerCase() &&
        s.grade._id === form.grade
    );

    if (
      matchedStudent &&
      form.enrollment !== matchedStudent.enrollment_number
    ) {
      setForm((prev) => ({
        ...prev,
        enrollment: matchedStudent.enrollment_number,
      }));
    }

    const gOrbList = Array.from(
      new Map(
        gOrbData
          .filter(
            (g) =>
              g.gender === form.gender.toLowerCase() &&
              g.grades.includes(form.grade) &&
              matchedStudent &&
              g.house.toString() === matchedStudent.house.toString()
          )
          .map((s) => [s._id, { _id: s._id, name: s.name }])
      ).values()
    );

    setGorB(gOrbList);

    if (gOrbList.length > 0 && form.group !== gOrbList[0]._id) {
      setForm((prev) => ({
        ...prev,
        group: gOrbList[0]._id,
      }));
    }
  }, [
    form.gender,
    form.grade,
    form.student,
    data,
    gOrbData,
    form.enrollment,
    form.group,
  ]);

  useEffect(() => {
    if (!form.grade) return;
    const gOrbList = Array.from(
      new Map(
        gOrbData
          .filter((g) => g.grades.includes(form.grade))
          .map((s) => [s._id, { _id: s._id, name: s.name }])
      ).values()
    );

    setGorB(gOrbList);
  }, [form.grade, gOrbData]);

  const getSuggestedSize = (productId, index, type) => {
    const sockSize = sockGuides?.size_guide?.[productId];
    if (sockSize) {
      return sockSize;
    }

    const list = type === "Topwear" ? products.topwear : products.bottomwear;
    if (!list?.length) return "";

    const primaryProduct = list[0];

    const primarySelectedVariantId = form.products?.find(
      (p) => p.productId === primaryProduct.productId
    )?.variantId;
    if (!primarySelectedVariantId) return "";

    const primarySelectedSizeObj = primaryProduct.sizes?.find(
      (s) => s.variantId === primarySelectedVariantId
    );
    const primarySelectedSize = primarySelectedSizeObj?.size;
    if (!primarySelectedSize) return "";

    if (index === 0) return "";

    const guides = size_guide?.filter((g) => g.styleType === type) || [];

    for (let g of guides) {
      if (g.mappingData.primarySize === primarySelectedSize) {
        const equivalent = g.mappingData?.equivalentSizes?.[productId];

        if (equivalent) {
          let suffix = "";
      
          const product =
            products.bottomwear?.find((p) => p.productId === productId) ||
            products.combined?.find((p) => p.productId === productId);

          const matchedTrackGuide = trackGuide?.find(
            (tg) => String(tg.category._id) === String(product?.category)
          );
          if (matchedTrackGuide && height) {
            const rule = matchedTrackGuide.sizeRules?.find(
              (r) => String(r.baseSize) === String(equivalent)
            );

            if (rule) {
              const range = rule.ranges?.find(
                (rg) => height >= rg.min && height < rg.max
              );

              if (range) {
                suffix = range.suffix || "";
              }
            }
          }

          return equivalent + suffix;
        }
      }
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (e.target.name === "enrollment") {
      const selectedStudent = data.find(
        (s) => s.enrollment_number === e.target.value
      );

      if (selectedStudent) {
        const genderLower = selectedStudent.gender.toLowerCase();
        const gradeId = selectedStudent.grade._id;

        const gOrbList = Array.from(
          new Map(
            gOrbData
              .filter(
                (g) =>
                  g.gender === genderLower &&
                  g.grades.includes(gradeId) &&
                  g.house.toString() === selectedStudent.house.toString()
              )
              .map((s) => [s._id, { _id: s._id, name: s.name }])
          ).values()
        );

        setForm((prev) => ({
          ...prev,
          enrollment: e.target.value,
          student: selectedStudent.name,
          gender:
            selectedStudent.gender.charAt(0).toUpperCase() +
            selectedStudent.gender.slice(1),
          grade: gradeId,
          group: gOrbList.length > 0 ? gOrbList[0]._id : "",
        }));

        setGorB(gOrbList);
      }
    } else if (
      e.target.name === "student" ||
      e.target.name === "grade" ||
      e.target.name === "gender"
    ) {
    }
  };

  const handleSizeChange = (productId, variantId) => {
    setForm((prev) => ({
      ...prev,
      products: prev.products.map((p) =>
        p.productId === productId ? { ...p, variantId } : p
      ),
    }));
  };

  const handleQuantityChange = (productId, qty) => {
    setForm((prev) => ({
      ...prev,
      products: prev.products.map((p) =>
        p.productId === productId ? { ...p, quantity: qty } : p
      ),
    }));
  };

  const getProducts = async () => {
    // Validation
    if (!form.group || form.group === "") {
      return swal({
        title: "Missing Selection",
        text: `Please select a ${mode === "group" ? "Group" : "Bundle"} first.`,
        icon: "warning",
        button: "OK",
      });
    }

    try {
      const url =
        mode === "group"
          ? "/api/schooluniform/products-by-group"
          : "/api/schooluniform/products-by-bundle";

      const resp = await axios.get(url, {
        params: { gOrbId: form.group },
      });
      setSizeGuide(resp.data.size_guide);
      setProducts(resp.data.products);
      console.log("the products are ", resp.data.products);
      const {
        topwear = [],
        bottomwear = [],
        combined = [],
      } = resp.data.products;

      const allProducts =
        combined.length > 0 ? combined : [...topwear, ...bottomwear];

      setForm((prev) => ({
        ...prev,
        products: allProducts.map((p) => ({
          productId: p.productId,
          variantId: "",
          quantity: mode === "group" ? 0 : p.quantity,
        })),
      }));
    } catch (err) {
      console.error(err);
      swal({
        title: "Error",
        text: "Failed to fetch products. Please try again.",
        icon: "error",
        button: "OK",
      });
    }
  };

  useEffect(() => {
    const fetchFilteredStudentNames = async () => {
      try {
        const schoolId = localStorage.getItem("schoolID");

        const resp = await axios.get("/api/schooluniform/filter-studentnames", {
          params: {
            schoolId,
            gender: form.gender ? form.gender.toLowerCase() : "",
            grade: form.grade || "",
          },
        });
        setStudentNames(resp.data.data);
      } catch (err) {
        console.error("Failed to fetch student names:", err);
      }
    };

    fetchFilteredStudentNames();
  }, [form.gender, form.grade]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const resp = await axios.post("/api/schooluniform/create", {
        ...form,
        mode,
      });
      console.log("Response:", resp.data);

      // Success popup
      swal({
        title: "Success!",
        text: "Form submitted successfully.",
        icon: "success",
        button: "OK",
      });

      // Optionally reset the form
      setForm({
        enrollment: "",
        student: "",
        gender: "",
        grade: "",
        group: "",
        products: [],
      });
    } catch (err) {
      console.error(err);

      // Error popup
      const errorMsg = err.response?.data?.message || "Something went wrong!";
      swal({
        title: "Error",
        text: errorMsg,
        icon: "error",
        button: "OK",
      });
    }
  };

  return (
    <div style={{ display: "flex", height: "100%" }}>
      <SchoolSidebar />
      <div
        className="container mt-5 p-3 shadow-lg rounded-4 bg-light border mb-4 w-full"
        // style={{ maxWidth: "800px" }}
      >
        <div style={{ width: "80%", margin: "0 auto" }}>
          <h3 className="mb-4 text-center fw-bold text-primary">
            Student Selection Form
          </h3>

          <Form
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "12px",
            }}
          >
            {/* Enrollment - Single Row */}
            <div className="col-md-3">
              <Form.Group className="mb-3">
                <Form.Label>Enrollment No</Form.Label>

                <Form.Control
                  list="enrollment-list"
                  name="enrollment"
                  value={form.enrollment}
                  onChange={handleChange}
                  disabled={
                    form.student !== "" ||
                    form.gender !== "" ||
                    form.grade !== ""
                  }
                  placeholder="Type or select enrollment"
                />

                <datalist id="enrollment-list">
                  {enrollmentNumbers.map((e, index) => (
                    <option key={index} value={e}>
                      {e}
                    </option>
                  ))}
                </datalist>
              </Form.Group>
            </div>
            <div className="text-center fw-bold">OR</div>

            {/* Student Name + Gender */}
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Select {mode === "group" ? "Group" : "Bundle"}
                  </Form.Label>

                  {/* Dropdown */}
                  <Form.Select
                    name="group"
                    value={form.group}
                    onChange={handleChange}
                  >
                    <option value="">
                      Select {mode === "group" ? "Group" : "Bundle"}
                    </option>

                    {gorb.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>Select Gender</Form.Label>
                  <Form.Select
                    name="gender"
                    value={form.gender}
                    onChange={handleChange}
                    disabled={form.enrollment !== ""}
                  >
                    <option>Select Gender</option>
                    {genders.map((g) => (
                      <option key={g} value={g}>
                        {g}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
            </div>

            {/* Grade + Group/Bundle */}
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>Select Grade</Form.Label>
                  <Form.Select
                    name="grade"
                    value={form.grade}
                    onChange={handleChange}
                    disabled={form.enrollment !== ""}
                  >
                    <option>Select Grade</option>
                    {grades.map((g) => (
                      <option key={g.id} value={g.id}>
                        {g.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>Student Name</Form.Label>

                  <Form.Control
                    list="students-list"
                    name="student"
                    value={form.student}
                    onChange={handleChange}
                    placeholder="Type or select student"
                    disabled={form.enrollment !== ""}
                  />

                  <datalist id="students-list">
                    {studentNames?.map((name, index) => (
                      <option key={index} value={name}>
                        {name}
                      </option>
                    ))}
                  </datalist>
                </Form.Group>
              </div>
            </div>

            {/* Height */}
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label>Height (cm)</Form.Label>
                  <Form.Control
                    type="number"
                    name="height"
                    placeholder="Enter height"
                    value={height}
                    onChange={(e) => setHeight(e.target.value)}
                    min={1}
                  />
                </Form.Group>
              </div>
            </div>

            <Button
              type="button"
              className="w-20"
              onClick={() => {
                getProducts();
              }}
            >
              Get Products
            </Button>
          </Form>
        </div>
        {/* PRODUCT LIST BELOW FORM */}
        {products.topwear?.length > 0 && (
          <div className="mt-4 p-3 shadow rounded bg-white">
            <h4 className="mb-3 text-primary fw-bold">Top Wear</h4>

            <table className="table table-hover table-striped border rounded">
              <thead>
                <tr>
                  <th>Product Name</th>
                  <th>Suggested size</th>
                  <th>Size</th>
                  <th>Qty</th>
                </tr>
              </thead>

              <tbody>
                {products.topwear?.map((p, index) => {
                  const formProduct = form.products.find(
                    (fp) => fp.productId === p.productId
                  );

                  return (
                    <tr key={p.productId}>
                      {/* Product Name */}
                      <td>{p.name}</td>

                      {/* Suggested Size */}
                      <td>
                        {getSuggestedSize(p.productId, index, "Topwear") || "-"}
                      </td>

                      {/* Sizes Dropdown */}
                      <td>
                        <Form.Select
                          value={formProduct?.variantId || ""}
                          onChange={(e) =>
                            handleSizeChange(p.productId, e.target.value)
                          }
                        >
                          <option value="" disabled>
                            Select size
                          </option>

                          {p.sizes?.map((s) => (
                            <option key={s.variantId} value={s.variantId}>
                              {s.size}
                            </option>
                          ))}
                        </Form.Select>
                      </td>

                      {/* Quantity Input */}
                      <td>
                        <Form.Control
                          type="number"
                          min="0"
                          value={formProduct?.quantity || 0}
                          onChange={(e) =>
                            handleQuantityChange(
                              p.productId,
                              Number(e.target.value)
                            )
                          }
                          disabled={mode !== "group"}
                          readOnly={mode !== "group"}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {/* PRODUCT LIST BELOW FORM */}
        {products.bottomwear?.length > 0 && (
          <div className="mt-4 p-3 shadow rounded bg-white">
            <h4 className="mb-3 text-primary fw-bold">Bottom Wear</h4>

            <table className="table table-hover table-striped border rounded">
              <thead>
                <tr>
                  <th>Product Name</th>
                  <th>Suggested size</th>
                  <th>Size</th>
                  <th>Qty</th>
                </tr>
              </thead>

              <tbody>
                {products.bottomwear?.map((p, index) => {
                  const formProduct = form.products.find(
                    (fp) => fp.productId === p.productId
                  );

                  return (
                    <tr key={p.productId}>
                      {/* Product Name */}
                      <td>{p.name}</td>

                      {/* Suggested Size */}
                      <td>
                        {getSuggestedSize(p.productId, index, "Bottomwear") ||
                          "-"}
                      </td>

                      {/* Sizes Dropdown */}
                      <td>
                        <Form.Select
                          value={formProduct?.variantId || ""}
                          onChange={(e) =>
                            handleSizeChange(p.productId, e.target.value)
                          }
                        >
                          <option value="" disabled>
                            Select size
                          </option>

                          {p.sizes?.map((s) => (
                            <option key={s.variantId} value={s.variantId}>
                              {s.size}
                            </option>
                          ))}
                        </Form.Select>
                      </td>

                      {/* Quantity Input */}
                      <td>
                        <Form.Control
                          type="number"
                          min="0"
                          value={formProduct?.quantity || 0}
                          onChange={(e) =>
                            handleQuantityChange(
                              p.productId,
                              Number(e.target.value)
                            )
                          }
                          disabled={mode !== "group"}
                          readOnly={mode !== "group"}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {/* PRODUCT LIST COMBINED BELOW FORM */}
        {products.combined?.length > 0 &&
          (products.topwear.length === 0 ||
            products.bottomwear.length === 0) && (
            <div className="mt-4 p-3 shadow rounded bg-white">
              <h4 className="mb-3 text-primary fw-bold">Product List </h4>

              <table className="table table-hover table-striped border rounded">
                <thead>
                  <tr>
                    <th>Product Name</th>
                    <th>Suggested Size</th>
                    <th>Size</th>
                    <th>Qty</th>
                  </tr>
                </thead>

                <tbody>
                  {products.combined?.map((p) => {
                    const formProduct = form.products.find(
                      (fp) => fp.productId === p.productId
                    );

                    return (
                      <tr key={p.productId}>
                        {/* Product Name */}
                        <td>{p.name}</td>
                        {/* Suggested Size */}
                        <td>
                          {getSuggestedSize(p.productId, null, "") || "-"}
                        </td>
                        {/* Sizes Dropdown */}

                        <td>
                          <Form.Select
                            value={formProduct?.variantId || ""}
                            onChange={(e) =>
                              handleSizeChange(p.productId, e.target.value)
                            }
                          >
                            <option value="" disabled>
                              Select size
                            </option>

                            {p.sizes?.map((s) => (
                              <option key={s.variantId} value={s.variantId}>
                                {s.size}
                              </option>
                            ))}
                          </Form.Select>
                        </td>
                        {/* Quantity Input */}
                        <td>
                          <Form.Control
                            type="number"
                            min="0"
                            value={formProduct?.quantity || 0}
                            onChange={(e) =>
                              handleQuantityChange(
                                p.productId,
                                Number(e.target.value)
                              )
                            }
                            disabled={mode !== "group"}
                            readOnly={mode !== "group"}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

        <div className="text-end mt-3">
          <Button variant="primary" onClick={handleSubmit}>
            Submit Order
          </Button>
        </div>
      </div>
    </div>
  );
}
